import {
  GraphQLFieldConfig,
  GraphQLNonNull,
  GraphQLObjectType,
  GraphQLString,
  GraphQLID
} from 'graphql'
import { Context } from '../shared'
import {
  VulnerabilitySubstatusAliasArgs,
  vulnerabilitySubstatusAliasArgs,
  substatusType
} from '../types/vulnerability-substatus-alias'
import { SubstatusName } from '../../../components/vulnerability-status/status'
import { Connector } from '../../../api/connector'

export const substatusAliasType = new GraphQLObjectType({
  name: 'substatusAlias',
  fields: () => ({
    organizationUuid: {
      description: 'The unique ID for the organization being queried',
      type: new GraphQLNonNull(GraphQLID)
    },
    substatus: {
      description:
        'The vulnerability substatus that is overridden by the vulnerability substatus alias',
      type: new GraphQLNonNull(substatusType)
    },
    alias: {
      description: 'The label assigned to the vulnerability substatus alias',
      type: new GraphQLNonNull(GraphQLString)
    }
  })
})

export const substatusAlias: GraphQLFieldConfig<
  any,
  Context,
  VulnerabilitySubstatusAliasArgs
> = {
  description: 'Get a substatus alias by substatus name',
  type: substatusAliasType,
  args: vulnerabilitySubstatusAliasArgs,
  resolve(_source, args, context) {
    const { organizationUuid, substatus } = args
    return findBySubtatusName(organizationUuid, substatus, context.connector)
  }
}

const normalizeSubstatusAlias = ({
  organization_uuid: organizationUuid,
  substatus,
  label: alias
}) => {
  return {
    organizationUuid,
    substatus,
    alias
  }
}

export async function findBySubtatusName(
  organizationUuid: string,
  substatus: SubstatusName,
  connector: Connector
) {
  const substatusAlias = await connector.get(
    `/organizations/${organizationUuid}/vulnerabilities/substatus/${substatus}`
  )
  return substatusAlias
    ? normalizeSubstatusAlias(substatusAlias.alias)
    : undefined
}
